module.exports = __webpack_public_path__ + "img/BAU Seniors_Infographics_65.84020507.png";